import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    component: () => import('../views/Login')
  },
  {
    path: '/data/realtime',
    redirect: '/data/realtime/overview'
  },
  {
    path: '/data/realtime/overview',
    component: () => import('../views/data/mp/realtime/Overview')
  },
  {
    path: '/data/user',
    redirect: '/data/user/overview'
  },
  {
    path: '/data/user/overview',
    component: () => import('../views/data/mp/user/Overview')
  },
  {
    path: '/data/user/new',
    component: () => import('../views/data/mp/user/New')
  },
  {
    path: '/data/user/details',
    component: () => import('../views/data/mp/user/Details')
  },
  {
    path: '/data/behavior',
    redirect: '/data/behavior/mp'
  },
  {
    path: '/data/behavior/mp',
    component: () => import('../views/data/mp/behavior/Mp')
  },
  {
    path: '/data/behavior/h5',
    component: () => import('../views/data/mp/behavior/H5')
  },
  {
    path: '/data/behavior/link',
    component: () => import('../views/data/mp/behavior/Link')
  },
  {
    path: '/data/content',
    redirect: '/data/content/index'
  },
  {
    path: '/data/content/index',
    component: () => import('../views/data/mp/content/Index')
  },
  {
    path: '/data/content/details',
    component: () => import('../views/data/mp/content/Details')
  },
  {
    path: '/setting/track',
    redirect: '/setting/track/group'
  },
  {
    path: '/setting/track/group',
    component: () => import('../views/setting/track/Group')
  },
  {
    path: '/setting/track/link',
    component: () => import('../views/setting/track/Link')
  },
  {
    path: '/setting/track/event',
    component: () => import('../views/setting/track/Event')
  },
  {
    path: '/setting/track/shortlink',
    component: () => import('../views/setting/track/ShortLink')
  },
  {
    path: '/setting/tag',
    redirect: '/setting/tag/type'
  },
  {
    path: '/setting/tag/type',
    component: () => import('../views/setting/tag/Type')
  },
  {
    path: '/setting/tag/manage',
    component: () => import('../views/setting/tag/Manage')
  },
  {
    path: '/setting/mini',
    redirect: '/setting/mini/group'
  },
  {
    path: '/setting/mini/group',
    component: () => import('../views/setting/mini/Group')
  },
  {
    path: '/setting/mini/custom',
    component: () => import('../views/setting/mini/Custom')
  },
  {
    path: '/setting/mini/channel',
    component: () => import('../views/setting/mini/Channel')
  },
  {
    path: '/setting/mini/scheme',
    component: () => import('../views/setting/mini/Scheme')
  },
  {
    path: '/setting/mini/link',
    component: () => import('../views/setting/mini/Link')
  },
  {
    path: '/setting/app',
    redirect: '/setting/app/group'
  },
  {
    path: '/setting/app/group',
    component: () => import('../views/setting/app/Group')
  },
  {
    path: '/setting/app/custom',
    component: () => import('../views/setting/app/Custom')
  },
  {
    path: '/setting/utm',
    redirect: '/setting/utm/link'
  },
  {
    path: '/setting/utm/link',
    component: () => import('../views/setting/utm/Link')
  },
  {
    path: '/setting/utm/group',
    component: () => import('../views/setting/utm/Group')
  },
  {
    path: '/system/system',
    redirect: '/system/system/customer'
  },
  {
    path: '/system/system/customer',
    component: () => import('../views/system/system/Customer')
  },
  {
    path: '/system/system/authorizer',
    component: () => import('../views/system/system/Authorizer')
  },
  {
    path: '/system/system/mini',
    component: () => import('../views/system/system/Mini')
  },
  {
    path: '/system/system/app',
    component: () => import('../views/system/system/App')
  },
  {
    path: '/system/system/user',
    component: () => import('../views/system/system/User')
  },
  {
    path: '/system/system/tenant',
    component: () => import('../views/system/system/Tenant')
  },
  {
    path: '/mp/material',
    redirect: '/mp/material/picture'
  },
  {
    path: '/mp/material/picture',
    component: () => import('../views/mp/material/Picture')
  },
  {
    path: '/mp/material/video',
    component: () => import('../views/mp/material/Video')
  },
  {
    path: '/mp/material/audio',
    component: () => import('../views/mp/material/Audio')
  },
  {
    path: '/mp/material/article',
    component: () => import('../views/mp/material/Article')
  },
  {
    path: '/mp/material/drafts',
    component: () => import('../views/mp/material/Drafts')
  },
  {
    path: '/mp/material/material',
    component: () => import('../views/mp/material/Material')
  },
  {
    path: '/mp/reply',
    redirect: '/mp/reply/article'
  },
  {
    path: '/mp/reply/article',
    component: () => import('../views/mp/reply/Article')
  },
  {
    path: '/mp/reply/video',
    component: () => import('../views/mp/reply/Video')
  },
  {
    path: '/mp/reply/text',
    component: () => import('../views/mp/reply/Text')
  },
  {
    path: '/mp/reply/mini',
    component: () => import('../views/mp/reply/Mini')
  },
  {
    path: '/mp/menu',
    redirect: '/mp/menu/layout'
  },
  {
    path: '/mp/menu/layout',
    component: () => import('../views/mp/menu/Layout')
  },
  {
    path: '/mp/menu/release',
    component: () => import('../views/mp/menu/Release')
  },
  {
    path: '/mp/group',
    redirect: '/mp/group/index'
  },
  {
    path: '/mp/group/index',
    component: () => import('../views/mp/group/Index')
  },
  {
    path: '/mp/group/user',
    component: () => import('../views/mp/group/User')
  },
  {
    path: '/mp/system',
    redirect: '/mp/system/reply'
  },
  {
    path: '/mp/system/reply',
    component: () => import('../views/mp/system/Reply')
  },
  {
    path: '/mp/system/qrcode',
    component: () => import('../views/mp/system/Qrcode')
  },
  {
    path: '/mp/system/mass',
    component: () => import('../views/mp/system/Mass')
  },
  {
    path: '/mp/system/shorturl',
    component: () => import('../views/mp/system/ShortUrl')
  },
  {
    path: '/mp/custom',
    redirect: '/mp/custom/template'
  },
  {
    path: '/mp/custom/template',
    component: () => import('../views/mp/custom/Template')
  },
  {
    path: '/mp/custom/message',
    component: () => import('../views/mp/custom/Message')
  },
  {
    path: '/mp/custom/package',
    component: () => import('../views/mp/custom/Package')
  },
  {
    path: '/mp/custom/article_tag',
    component: () => import('../views/mp/custom/ArticleTag')
  },
  {
    path: '/mp/custom/user_tag',
    component: () => import('../views/mp/custom/UserTag')
  },
  {
    path: '/mp/custom/track_reply',
    component: () => import('../views/mp/custom/Track')
  },
  {
    path: '/package/package_filter',
    component: () => import('../views/package/PackageFilter')
  },
  {
    path: '/package/sp_package_filter',
    component: () => import('../views/package/SpPackageFilter')
  },
  {
    path: '/data/utm_data',
    redirect: '/data/utm/index'
  },
  {
    path: '/data/insight',
    redirect: '/data/utm/insight'
  },
  {
    path: '/data/utm/index',
    component: () => import('../views/data/utm/Index')
  },
  {
    path: '/data/utm/insight',
    component: () => import('../views/data/utm/Insight')
  },
  {
    path: '/data/sp_realtime',
    redirect: '/data/sp_realtime/overview'
  },
  {
    path: '/data/sp_realtime/overview',
    component: () => import('../views/data/sp/realtime/Overview')
  },
  {
    path: '/data/sp_user',
    redirect: '/data/sp_user/overview'
  },
  {
    path: '/data/sp_user/overview',
    component: () => import('../views/data/sp/user/Overview')
  },
  {
    path: '/data/sp_user/new',
    component: () => import('../views/data/sp/user/New')
  },
  {
    path: '/data/sp_user/details',
    component: () => import('../views/data/sp/user/Details')
  },
  {
    path: '/data/sp_behavior',
    redirect: '/data/sp_behavior/overview'
  },
  {
    path: '/data/sp_behavior/overview',
    component: () => import('../views/data/sp/behavior/Overview')
  },
  {
    path: '/data/sp_behavior/share',
    component: () => import('../views/data/sp/behavior/Share')
  },
  // v2
  {
    path: '/data/sp_v2_realtime',
    redirect: '/data/sp_v2_realtime/overview'
  },
  {
    path: '/data/sp_v2_realtime/overview',
    component: () => import('../views/data/sp_v2/realtime/Overview')
  },
  {
    path: '/data/sp_v2_user',
    redirect: '/data/sp_v2_user/overview'
  },
  {
    path: '/data/sp_v2_user/overview',
    component: () => import('../views/data/sp_v2/user/Overview')
  },
  {
    path: '/data/sp_v2_user/new',
    component: () => import('../views/data/sp_v2/user/New')
  },
  {
    path: '/data/sp_v2_user/details',
    component: () => import('../views/data/sp_v2/user/Details')
  },
  {
    path: '/data/sp_v2_behavior',
    redirect: '/data/sp_v2_behavior/overview'
  },
  {
    path: '/data/sp_v2_behavior/overview',
    component: () => import('../views/data/sp_v2/behavior/Overview')
  },
  {
    path: '/data/sp_v2_behavior/share',
    component: () => import('../views/data/sp_v2/behavior/Share')
  }
]

const router = new VueRouter({
  routes
})

export default router
